module.exports = __webpack_public_path__ + "static/img/logo-django.624de952.png";